import React from 'react'
import Chart from './chartComponent'
import Donatchart from './donatchart'
import ChartComponent from './chartComponent'

const Overview = () => {

  // function truncateText(text, wordLimit = 10) {
  //     const words = text.split(" ");
  //     return words.length > wordLimit 
  //         ? words.slice(0, wordLimit) + "..." 
  //         : text;
  // }

  return (
    <div>
      <ChartComponent />
    </div>
  )
}

export default Overview;